import { createSlice } from "@reduxjs/toolkit";
import { getClassificationsMessage } from "../actions/fluxoNSimilar";

interface SessionMessage {
  content: any[];
  page: number;
  [key: string]: any;
}

export interface ClassificationsMessageState {
  sessionClassificationsMessage: SessionMessage;
  status: "idle" | "loading" | "ready" | "error";
  error: unknown | null;
  httpStatus: number | null;
  messageStatus: null;
}

const initialState: ClassificationsMessageState = {
  sessionClassificationsMessage: {
    content: [],
    page: 0,
  },
  status: "idle",
  error: null,
  httpStatus: null,
  messageStatus: null,
};

const sessionClassificationsMessageSlice = createSlice({
  name: "sessionClassificationsMessage",
  initialState,
  reducers: {
    resetClear(state) {
      return initialState;
    },
    resetClassifications(state) {
      state.sessionClassificationsMessage = {
        content: [],
        page: 0,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getClassificationsMessage.pending, (state) => {
        state.status = "loading";
        state.error = null;
        state.httpStatus = null;
      })
      .addCase(getClassificationsMessage.rejected, (state, action) => {
        state.status = "error";
        state.sessionClassificationsMessage = {
          content: [],
          page: 0,
        };
        state.httpStatus = action.payload?.httpStatus || null;
      })
      .addCase(getClassificationsMessage.fulfilled, (state, action) => {
        state.status = "ready";
        state.sessionClassificationsMessage = action.payload.message;
        state.error = null;
        state.httpStatus = 200;
      });
  },
});

export const { resetClear, resetClassifications } =
  sessionClassificationsMessageSlice.actions;

export default sessionClassificationsMessageSlice.reducer;
